import { createFileRoute, Outlet } from '@tanstack/react-router'

import { Footer } from '@/components/footer'
import { Header } from '@/components/header'
import { store } from '@/store'

export const Route = createFileRoute('/_layout')({
  component: LayoutComponent,
  beforeLoad: ({ location }) => {
    const state = store.getState()

    if (state.isInitialized && state.isAuthorized && state.user && !state.termsAccepted) {
      if (location.pathname !== '/login/oauth/start') {
        window.location.href = '/login/oauth/start?type=oauth'
      }
    }
  },
})

function LayoutComponent() {
  return (
    <div className="mx-auto flex min-h-full w-full max-w-[1280px] shrink-0 grow flex-col px-6 pt-[36px] sm:px-4">
      <Header />
      <main className="flex grow flex-col py-18 sm:py-12">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
